import React, { lazy } from 'react';
export function Visitanos() {
  return <section id="visitanos" className="tex-crema py-12 md:py-24 px-6 md:px-12" data-id="element-165">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-start" data-id="element-166">
        {/* MAPA — aparece arriba en mobile y a la derecha en desktop */}
        <div className="md:order-2 w-full aspect-[4/3] md:aspect-square overflow-hidden rounded-sm border border-marron/20 shadow-sm" data-id="element-167">
          <iframe title="Ubicación de Lloq'e en Purmamarca, Jujuy" src="https://maps.google.com/maps?q=-23.746822,-65.499474&z=18&output=embed" className="w-full h-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-168"></iframe>
        </div>

        <div className="md:order-1 flex flex-col justify-center items-start md:pt-16 lg:pt-24" data-id="element-169">
          <h2 className="font-labrada font-bold text-4xl md:text-5xl text-negro mb-8 leading-tight" data-id="element-170">
            Vení al Lloq'e
          </h2>
          <p className="font-labrada text-lg md:text-xl text-negro leading-relaxed mb-10" data-id="element-171">
            Encontranos en Purmamarca, en el corazón de la Quebrada de
            Humahuaca, Jujuy. Vení a vernos tejer, conocer la historia y
            llevarte una pieza única hecha con fibras 100% naturales.
          </p>
          <a href="https://wa.me/" target="_blank" rel="noopener noreferrer" className="bg-marron text-crema font-labrada px-8 py-4 rounded-sm hover:opacity-90 transition-opacity text-lg inline-block" data-id="element-172">
            Escribinos por WhatsApp
          </a>
        </div>
      </div>
    </section>;
}